import { render, staticRenderFns } from "./ReturnTopButton.vue?vue&type=template&id=8cf030ea&scoped=true"
import script from "./ReturnTopButton.vue?vue&type=script&lang=ts"
export * from "./ReturnTopButton.vue?vue&type=script&lang=ts"
import style0 from "./ReturnTopButton.vue?vue&type=style&index=0&id=8cf030ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf030ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
